export enum ReturnToWork {
    YES_FULL_TIME = 'Yes, full-time',
    YES_PART_TIME = 'Yes, part-time',
    NO = 'No'
}